<template>
    <div class="lat-nav" :class="selected">

      <div class="lat-nav-dots">
        <div></div>
        <div></div>
        <div></div>
        <div></div>

      </div>

    </div>
</template>

<script>



    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS} from '../../main';


    export default {

        name: 'lat-nav',
      props: ['actRoute', 'isMobile', 'lang'],
        data() {
            return {
              selected: ''

            }
        },

        created() {


        },
        mounted() {

            //EVENTBUS.$on('AAA', AAA);
            //EVENTBUS.$emit('AAA', 0);
          EVENTBUS.$on('changeLatNav', this.changeLatNav);
        },

        destroyed() {

        },

        methods: {

            changeLatNav(n) {

              this.selected = 'selected' + n;


            }
        },
    };

</script>


// WEBPACK FOOTER //
// src/components/Modules/LatNav.vue